import { Component, OnInit } from '@angular/core';
import { CustomDataService } from '../services/custom-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'genres',
  templateUrl: './genres.component.html',
  styleUrls: ['./genres.component.css']
})
export class GenresComponent implements OnInit {

  myTypes
  constructor(private custom:CustomDataService , private _router:Router) 
  {
    this.myTypes = this.custom.types
   }

  ngOnInit() {
  }

  goToType(type)
  {
    this._router.navigate(["/Movie/Type",type.toUpperCase()]);
  }
}
